import Turbolinks from "turbolinks";
Turbolinks.start();

import Rails from "@rails/ujs";
Rails.start();

import "src/public/stylesheets/public.scss";
import "src/fonts/canela/font_face.scss";
import "src/fonts/gt_walsheim/font_face.scss";
import "src/fonts/visuelt/font_face.scss";

// Tailwind CSS
import "src/public/stylesheets/tailwind.css";

// Visuelt Fonts
import "src/fonts/visuelt-pro/font_face.scss";

// Images
require.context("src/public/images", true);

// Require legacy mail images
// TODO: Remove after March 2020
require.context("packs/public/images/mail", true);
